import type { ReactNode } from 'react';
import { Spinner } from '@/components/ui/spinner';
import { cn } from '@/lib/utils';

interface TableLoadingOverlayProps {
  loading: boolean;
  children: ReactNode;
  className?: string;
}

export function TableLoadingOverlay({
  loading,
  children,
  className,
}: TableLoadingOverlayProps) {
  return (
    <div className={cn('relative', className)}>
      {children}
      {loading && (
        <div
          className="absolute inset-0 z-10 flex items-center justify-center bg-background/60 backdrop-blur-[1px] rounded-md"
          aria-live="polite"
          aria-busy="true"
        >
          <Spinner size="lg" color="primary" />
        </div>
      )}
    </div>
  );
}

export default TableLoadingOverlay;
